import { AxiosResponse } from "axios";
import API from "../api";
import { JobMode } from "../models/job.mode";

const ModeJobService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/modes/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<JobMode[]>> {
    return await API.get(`/modes`, { params: options });
  },
  async create(mode: JobMode): Promise<AxiosResponse<JobMode>> {
    return await API.post("/modes", mode);
  },
  async update(id: number, mode: JobMode): Promise<AxiosResponse<boolean>> {
    return await API.put(`/modes/${id}`, mode);
  },
};

export default ModeJobService;
